<script setup>
/*
 * Gennemsnittet af sidens delvurderinger.
 *
 * Viser INGENTING hvis der ikke er nogen delvurderinger. En samlet score
 * paa nul ud af fem, fordi ingen har givet karakter, er vaerre end ingen
 * score.
 */
import { sanitizeHtml } from '@/Utils/sanitize';
import { computed } from 'vue';

const props = defineProps({ data: { type: Object, required: true } });

const html = computed(() => sanitizeHtml(props.data.tekst || ''));
const procent = computed(() => (props.data.score ? (Number(props.data.score) / 5) * 100 : 0));
</script>

<template>
    <div class="samlet">
        <div v-if="data.score" class="row align-items-center g-3">
            <div class="col-auto">
                <div class="score">
                    <span class="score__tal">{{ data.score }}</span>
                    <span class="score__af">/ 5</span>
                </div>
                <div class="progress mt-2" style="height: .4rem">
                    <div class="progress-bar" :style="{ width: procent + '%' }"></div>
                </div>
                <p class="small text-secondary mt-1 mb-0">
                    Gennemsnit af {{ data.antal }} {{ data.antal === 1 ? 'delkarakter' : 'delkarakterer' }}
                </p>
            </div>
            <div class="col">
                <div v-if="html" v-html="html"></div>
            </div>
        </div>

        <div v-else>
            <div v-if="html" v-html="html"></div>
            <p v-else class="text-secondary small mb-0">Ingen delvurderinger på siden endnu.</p>
        </div>
    </div>
</template>

<style scoped>
.score { text-align: center; min-width: 6rem; }
.score__tal { font-size: 2.5rem; font-weight: 700; line-height: 1; }
.score__af { color: var(--pc-text-secondary); margin-left: .25rem; }
</style>
